export const storageItemMainQueryKey = "storage-items";
